export default function AboutData() {
  return {
    title: "Get To Know Term Life Insurance",
    description: "Term life insurance is a type of life insurance that provides coverage for a specific period, ranging from 10 to 40 years. It's generally more affordable than permanent life insurance, making it ideal for those looking to cover temporary financial obligations such as mortgages, debts, or income replacement for dependents.",
    productSpecifications: [
      {
        iconName: "m_cake",
        title: "Who can apply?",
        description: "U.S. citizens or permanent residents age 18-70"
      },
      {
        iconName: "m_calendarToday",
        title: "Term Lengths",
        description: "10 to 40 year terms"
      },
      {
        iconName: "m_moneyBag",
        title: "Coverage Amounts",
        description: "$50,000 - $10,000,000"
      },
      {
        iconName: "m_shield",
        title: "Death Benefit",
        description: "Lump sum payment, that is typically paid tax free"
      },
    ]
  };
};